import { ref } from 'vue';

export default function useComponentFilters(props) {
  let resource = props.resource ?? props.models ?? props.model;
  let meta = props.meta ?? resource.meta;

  const buildFilters = (filterValues, filterKeys) => {
    for (let key in filterKeys) {
      let attribute = filterKeys[key];
      if (!filterValues[attribute]) {
        filterValues[attribute] =
          meta.columns[attribute] === 'timestamp' ||
          meta.columns[attribute] === 'date' ||
          meta.columns[attribute] === 'datetime'
            ? { min: '', max: '' }
            : '';
      }
    }

    return { ...filterValues };
  };

  const localFilter = ref(
    buildFilters(
      ref(props.filter ?? props.adjustments?.filter ?? meta?.adjustments.filter ?? {}).value,
      Object.keys({ ...meta }.columns)
    )
  );

  const getActiveFilters = () => {
    let activeFilters = {};
    for (let filterName in localFilter.value) {
      let filterValue = localFilter.value[filterName];
      if (filterValue) {
        if (typeof filterValue === 'string') {
          activeFilters[filterName] = filterValue;
        } else if (filterValue.min || filterValue.max) {
          activeFilters[filterName] = (filterValue.min ?? '<') + ' - ' + (filterValue.max ?? '>');
        }
      }
    }

    return activeFilters;
  };

  const paramsWithoutFilter = (column) => {
    let tempFilter = Object.assign({}, localFilter.value); // fixme: workaround to deep clone object
    tempFilter[column] = 'RESET';

    return {
      sort: props.sort ?? props.adjustments?.sort,
      filter: tempFilter,
      relation: props.options?.relation?.name ?? props.resource.meta.relationInfo?.name,
      parent: props.options?.parent ?? props.parentResource ?? props.resource.meta.relationInfo?.parentType,
    };
  };

  const updateParams = (params) => {
    localFilter.value = params.filter;
  };

  return {
    buildFilters,
    getActiveFilters,
    localFilter,
    paramsWithoutFilter,
    updateParams,
  };
}
